import { render, staticRenderFns } from "./decision-card.vue?vue&type=template&id=efdf4b66&scoped=true&"
import script from "./decision-card.vue?vue&type=script&lang=js&"
export * from "./decision-card.vue?vue&type=script&lang=js&"
import style0 from "./decision-card.vue?vue&type=style&index=0&id=efdf4b66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efdf4b66",
  null
  
)

export default component.exports